import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../component/Sidebar/SideBar";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { useTranslation } from "react-i18next";
import { AuthUserContext } from "../../context/context";
import { toast } from "react-toastify";
import DataTables from "../../component/DataTable";
import { useNavigate } from "react-router-dom";
import getPendingUsers from "../../services/packages/getPendingUserList";
import approvePendingUser from "../../services/packages/approvependingUser";
import resendOTP from "../../services/auth/resendOTP";

const PendingUsers = () => {
  const { t } = useTranslation();
  const { currentLocalization, setToastId, user } = useContext(AuthUserContext);
  const [users, setUsers] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("null");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sortedUsers, setSortedUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [minDate, setMinDate] = useState("");
  const [appliedStartDate, setAppliedStartDate] = useState("");
  const [appliedEndDate, setAppliedEndDate] = useState("");
  const [selectedRows, setSelectedRows] = useState({});
  
  
  const columns = [
    {
      name: <span className="dataTable-text">{t("table.username")}</span>,
      key: "name",
      selector: (row) => row.package,
      cell: (row) => (
        <span className="text-start column-text">{row?.name}</span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: <span className="dataTable-text">{t("table.phone_no")}</span>,
      key: "phone_no",
      cell: (row) => (
        <span className="text-start column-text">{row?.phone_no}</span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: <span className="dataTable-text">{t("table.email")}</span>,
      key: "email",
      selector: (row) => <span className="column-text">{row?.email}</span>,
      sortable: true,
      width: "280px",
    },
    {
      name: <span className="dataTable-text">{t("table.countries")}</span>,
      key: "countries",
      selector: (row) => (
        <span>
          {row.countries.map((country, index) => (
            <span key={country} className="column-text">
              {country}
              {index !== row.countries.length - 1 && ", "}
            </span>
          ))}
        </span>
      ),
      sortable: true,
      width: "250px",
    },
    {
    name: <span className="dataTable-text">{t("")}</span>,
    selector: (row) => (
      <button
        className="view-btn1 px-3 py-1 text-sm text-green-600 bg-orange-600 rounded hover:bg-green-700 border-white outline-none border-none"
        onClick={() => handleOTP(row)}
      >
        Resend OTP
      </button>
    ),
    width: "160px",
    sortable: false,
  },

  {
    name: <span className="dataTable-text">{t("")}</span>,
    selector: (row) => (
      <button
        className="view-btn2 px-3 py-1 text-sm text-green-600 bg-green-600 rounded hover:bg-green-700 border-white outline-none border-none"
        onClick={() => handleApprove(row)}
      >
        Approve
      </button>
    ),
    width: "140px",
    sortable: false,
  },
    // {
    //       name: "",
    //       selector: (row) => (
    //         <span className="column-text">
    //           <UserListingDataTableMenu
    //             handleApprove={() => handleApprove(row)}
    //             handleOTP={() => handleOTP(row)}
    //             row={row}
    //             selectedRows={selectedRows}
    //           />
    //         </span>
    //       ),
    //       width: "120px",
    //       ignoreRowClick: true, // prevents triggering row click when button is clicked
    //       allowOverflow: true,  // ensures the button isn't clipped
    //       button: true,
    //     },
  ];

  const handleApprove = async (row) => {

    console.log("Approved row:", row._id);
    try{
       const response = await approvePendingUser(row._id);

       if(response.status) {
        const id = toast.success(response?.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
        const usersResponse = await getPendingUsers({
        startDate,
        endDate,
        search
        });

        if (usersResponse.success) {
            setUsers(usersResponse.data.user);
            setSortedUsers(usersResponse.data.user);
            setStartDate(usersResponse.data.startDate);
            setEndDate(usersResponse.data.endDate);
        if (!minDate) setMinDate(usersResponse.data.startDate);
        if (!appliedStartDate && !appliedEndDate) {
             setStartDate(usersResponse.data.startDate);
             setEndDate(usersResponse.data.endDate);
        }
      }
       }

    }catch(error) {
      const id = toast.error(error?.message || error.message, {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        pauseOnHover: true,
      });
      setToastId(id);
    }
    setSelectedRows(row);
  }
  const handleOTP = async  (row) => {
    console.log("Send OTP for row:", row);
    try{

      let lang;
      if (currentLocalization.startsWith("en-")) {
        lang = "en";
      } else {
        lang = currentLocalization;
      }
      const object = {
        phone_no: row.phone_no,
        lang: lang,
      };
      console.log(object);
      
    const response = await resendOTP(object);

     if(response.success) {
        const id = toast.success(response?.message, {
          autoClose: true,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
    }

  } catch(error){
     const id = toast.error(error?.message || error.message, {
        autoClose: true,
        closeOnClick: false,
        draggable: false,
        pauseOnHover: true,
      });
      setToastId(id);
  }
}
  const handleSort = async (column, direction) => {
    const sortedData = [...users].sort((a, b) => {
      if (a[column.key] < b[column.key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[column.key] > b[column.key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    setSortedUsers(sortedData);
  };
  const getUsers = async (startDate = null, endDate = null, search = "") => {
    setLoading(true);
    try {
      const usersResponse = await getPendingUsers({
        startDate,
        endDate,
        search,
      });
      if (usersResponse.success) {
        setUsers(usersResponse.data.user);
        setSortedUsers(usersResponse.data.user);
        setStartDate(usersResponse.data.startDate);
        setEndDate(usersResponse.data.endDate);
        if (!minDate) setMinDate(usersResponse.data.startDate);
        if (!appliedStartDate && !appliedEndDate) {
          setStartDate(usersResponse.data.startDate);
          setEndDate(usersResponse.data.endDate);
        }
      }
    } catch (err) {
      const userDetails = JSON.parse(localStorage.getItem("USER_DETAILS"));
      const userRole = userDetails?.role;
      if (userRole === "user") {
        navigate("/data-usage");
        return;
      }
      if (userRole === "member") {
        navigate("/content-management");
        return;
      }
      if (err.response?.status === 401) {
        const id = toast.error(t("toastsMessage.part4"), {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
        window.scroll(0, 0);
        localStorage.clear();
        navigate("/log-in");
      } else {
        console.log("err", err);
        const id = toast.error(err.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      }
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getUsers(appliedStartDate, appliedEndDate, search);
  }, [appliedStartDate, appliedEndDate, search]);

  return (
    <Sidebar>
      <Container>
        <Row className="d-flex align-items-center justify-content-between">
          <Col xs="auto">
            <div
              className={
                currentLocalization === "ar" ? "text-end" : "text-start"
              }
            >
              <h2 className="package-h2">{t("Pending Users")}</h2>
            </div>
          </Col>
          <Col
            xs="auto"
            className="d-flex justify-content-end align-items-center gap-2 flex-wrap"
          >
          </Col>
        </Row>
        <Row>
          <Col
            className={currentLocalization === "ar" ? "text-end" : "text-start"}
          >
            <div className="mt-4">
              <DataTables
                columns={columns}
                data={sortedUsers.length ? sortedUsers : users}
                loading={loading}
                handleSort={handleSort}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </Sidebar>
  );
};

export default PendingUsers;
